import { InputTextareaModule } from 'primeng/inputtextarea';
import { FieldsetModule } from 'primeng/fieldset';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';

import { TranslateModule } from '@ngx-translate/core';

import { TrapFocusDirective } from './directives/trap-focus.directive';

import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PageCardComponent } from './components/page-card/page-card.component';

import { CheckboxModule } from 'primeng/checkbox';
import { PaginatorModule } from 'primeng/paginator';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { UnsavedChangesModalComponent } from '@shared/components/unsaved-changes-modal/unsaved-changes-modal.component';
import { DialogModule } from 'primeng/dialog';
import { SearchbarComponent } from '@shared/components/searchbar/searchbar.component';
import { USDPipe, DecimalPipe } from './pipes';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { ActionsButtonComponent } from './components/actions-button/actions-button.component';
import { CharacterCounterComponent } from './components/character-counter/character-counter.component';
import { UnauthorizedPageComponent } from './components/unauthorized-page/unauthorized-page.component';
import { AccountClearCookiesComponent } from '@shared/components/account-clear-cookies/account-clear-cookies.component';

@NgModule({
    declarations: [
        TrapFocusDirective,
        ErrorPageComponent,
        PageCardComponent,
        LoaderComponent,
        UnsavedChangesModalComponent,
        SearchbarComponent,
        USDPipe,
        DecimalPipe,
        InfoTooltipComponent,
        ActionsButtonComponent,
        CharacterCounterComponent,
        UnauthorizedPageComponent,
        AccountClearCookiesComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        TranslateModule,
        ButtonModule,
        CheckboxModule,
        PaginatorModule,
        ReactiveFormsModule,
        ReactiveFormsModule,
        DialogModule,
        DividerModule,
        InputTextModule,
        FieldsetModule,
        InputTextareaModule,
        TooltipModule,
    ],
    exports: [
        FormsModule,
        TranslateModule,
        TrapFocusDirective,
        ErrorPageComponent,
        PageCardComponent,
        ReactiveFormsModule,
        LoaderComponent,
        UnsavedChangesModalComponent,
        SearchbarComponent,
        InfoTooltipComponent,
        ActionsButtonComponent,
        CharacterCounterComponent,
        InfoTooltipComponent,
        AccountClearCookiesComponent,

        //* Pipes
        USDPipe,
        DecimalPipe,

        // * PrimeNG
        CheckboxModule,
        PaginatorModule,
        DividerModule,
        TooltipModule,
        InputTextModule,
        ButtonModule,
        UnauthorizedPageComponent,
    ],
    providers: [DecimalPipe],
})
export class SharedModule {}
